import React, { useEffect } from "react";
import './index.css'
import { useDisableScroll } from "../../hooks/useDisableScroll";
import { useScrollTop } from "../../hooks/useScrollTop";


const Modal = ({children, openModal})=>{
    useScrollTop();
    useDisableScroll()

    return(
        <div className="modal-container">
            {children}
        </div>
    )
}

export default Modal